<template>
    <app-layout>
        <template #main-content>
            <main id="content" class="l-main p-homework">
                <div class="l-main__inner">
                    <div class="p-homework-header">
                        <div  class="p-homework-header__date">
                        <p>今日は<span class="month">{{ current_date.getMonth() + 1 }}</span>月<span class="date">{{ current_date.getDate() }}</span>日({{ day_symbol[current_date.getDay()] }})</p>
                        </div>
                        <div class="c-parts-toggle-area">
                        <div class="c-parts-toggle-title">終わった宿題は表示しない</div>
                        <div :class="{'c-parts-toggle':true,'c-parts-toggle--active': homeworkStore.isHomeworkCompleted}" @click="toggleSwitch()" :name="getToggleSentryName">
                            <span class="label">{{homeworkStore.isHomeworkCompleted?'ON':'OFF'}}</span>
                            <span class="toggle"></span>
                        </div>
                        </div> 
                    </div>
                    <div class="p-homework__switch-area">
                        <ul class="p-homework__switch">
                            <li :class="{'current': homeworkStore.isHomeworkCurrent}">
                                <router-link :to="{ name: 'current-homework' }" class="p-homework__switch-item -left" :name="getCurrentSentryName">今の宿題</router-link>
                            </li>
                            <li :class="{'current': !homeworkStore.isHomeworkCurrent}">
                                <router-link :to="{ name: 'expired-homework' }" class="p-homework__switch-item -right" :name="getExpiredSentryName">過去の宿題</router-link>
                            </li>
                        </ul>
                    </div>
                    <!-- Render current or expired homework content here -->
                    <slot name="homework-content"></slot>
                </div>
            </main>
        </template>
    </app-layout>
</template>
<script setup lang="ts">
  import {ref, onMounted, computed} from 'vue';
  import { useWorkStore } from '@/store/student/work_store';
  import { useHomeworkStore } from '@/store/student/homework_store';
  import { useGlobalNavigationStore } from '@/store/student/global_navigation_store';

  const workStore = useWorkStore();
  const homeworkStore = useHomeworkStore();
  const globalNavigationStore = useGlobalNavigationStore()
  
  const current_date = ref(new Date())
  const day_symbol = ref(["日", "月", "火", "水", "木", "金", "土"])
  onMounted(async() =>{
    document.title = "宿題一覧"
    globalNavigationStore.saveSelectedMenu("homework")
    await homeworkStore.fetchHomeworkQuestionSet()
    workStore.saveMission(null)
  })
  const getToggleSentryName = computed(() => {
    return homeworkStore.isHomeworkCurrent ? "S9-1-hw-completed-toggle-btn" : "S9-2-hw-completed-toggle-btn"
  })
  const getCurrentSentryName = computed(() => {
    return homeworkStore.isHomeworkCurrent ? "S9-1-current-hw-btn" : "S9-2-current-hw-btn"
  }) 
  const getExpiredSentryName = computed(() => {
    return homeworkStore.isHomeworkCurrent ? "S9-1-expired-hw-btn" : "S9-2-expired-hw-btn"
  }) 
  function toggleSwitch() {
    homeworkStore.saveIsHomeworkCompleted(!homeworkStore.isHomeworkCompleted)
  }
</script>